'use client';

import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import WhatsAppIcon from 'components/ui/WhatsAppIcon';
import { getWhatsAppUrl } from 'lib/whatsapp';
import { cn } from 'lib/utils';

export default function FloatingButtons() {
  const [isVisible, setIsVisible] = useState(false);

  // Show scroll-to-top button when scrolling down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="fixed bottom-4 right-3.5 sm:bottom-6 sm:right-6 z-[40] flex flex-col gap-2.5 sm:gap-3 items-center">
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={cn(
          "w-11 h-11 sm:w-12 sm:h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-singaraa-ivory border border-singaraa-caramel/20 text-singaraa-dark shadow-md hover:bg-singaraa-beige/50 transition-all duration-300",
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        )}
        aria-label="Scroll to top"
      >
        <ArrowUp className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
      </button>

      {/* WhatsApp Chat Button */}
      <a
        href={getWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-11 h-11 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 hover:bg-[#1da851] transition-all duration-300 hover:scale-110 active:scale-95 flex items-center justify-center group"
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute -inset-1 rounded-full bg-[#25D366]/30 animate-ping pointer-events-none" />
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 relative z-10" />
        {/* Tooltip for desktop */}
        <span className="absolute right-full mr-4 px-3 py-1.5 bg-singaraa-dark text-white text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none hidden md:block">
          Chat with us
        </span>
      </a>
    </div>
  );
}
